/* Problematic Tees theme. Plain JavaScript, no dependencies. v06 */
(function () {
  'use strict';
  var PT = window.PT || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var lastFocus = null;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('.toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 4000);
  }
  function lock(on) { document.body.classList.toggle('is-locked', on); document.documentElement.style.overflow = on ? 'hidden' : ''; }

  /* ---------- Cart quantity cap (v07.2) ----------
     Total tees per cart <= PT.cap.max (theme setting "Max tees per cart", default 12). The cart count is kept from
     /cart.js responses (pt:cart:updated); PT.cap.count is only the first-paint value rendered by Liquid. */
  /* cap-math:start */
  function capLeftOf(max, count) { return Math.max(0, max - count); }
  function capAllows(max, count, delta) { return delta <= 0 || count + delta <= max; }
  function capClamp(max, count, want) {
    var left = capLeftOf(max, count), n = parseInt(want, 10);
    if (isNaN(n) || n < 1) n = 1;
    return Math.min(n, left);
  }
  /* cap-math:end */
  var CAP = {
    max: Math.max(1, parseInt(PT.cap && PT.cap.max, 10) || 12),
    count: Math.max(0, parseInt(PT.cap && PT.cap.count, 10) || 0),
    hooks: []
  };
  function capNoteText() { return (PT.strings && PT.strings.capNote) || ''; }
  /* show the cap message in every cart/drawer region and lock the + buttons when the cart is at the cap; PDP regions are driven by initProduct */
  function capRender() {
    var at = CAP.count >= CAP.max;
    $$('[data-cap-note]').forEach(function (n) {
      if (n.getAttribute('data-cap-ctx') === 'pdp') return;
      var m = $('[data-cap-msg]', n);
      if (m) m.hidden = !at;
    });
    $$('[data-cap-plus]').forEach(function (b) { b.disabled = at; });
    CAP.hooks.forEach(function (fn) { fn(); });
  }
  function capSetCount(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    CAP.count = n;
    capRender();
  }
  document.addEventListener('pt:cart:updated', function (e) { if (e.detail) capSetCount(e.detail.item_count); });
  /* back/forward cache can restore a stale page: re-read the cart */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) fetch(PT.routes.cart + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { capSetCount(c.item_count); }).catch(function () {});
  });
  function capReject() {
    var err = new Error(capNoteText() || PT.strings.error);
    err.cap = true;
    return Promise.reject(err);
  }
  /* an attempt to go past the cap: show the message (all cart regions) and flag it for the PDP */
  function capBlocked() {
    $$('[data-cap-note]').forEach(function (n) { var m = $('[data-cap-msg]', n); if (m && n.getAttribute('data-cap-ctx') !== 'pdp') m.hidden = false; });
    CAP.hooks.forEach(function (fn) { fn(true); });
  }
  /* checkout stays closed while the cart is over the cap, even if the button was rendered before the count changed */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (CAP.count > CAP.max && f && f.querySelector && f.querySelector('[name="checkout"]')) { e.preventDefault(); capBlocked(); }
  });

  /* ---------- Cart: drawer + events ---------- */
  var drawer = function () { return $('#cart-drawer'); };
  var overlay = function () { return $('.drawer-overlay'); };
  function openDrawer() {
    var d = drawer();
    if (!d) return false;
    if (!d.classList.contains('is-open')) lastFocus = document.activeElement;
    d.classList.add('is-open');
    if (overlay()) overlay().hidden = false;
    lock(true);
    var c = $('[data-close-cart]', d);
    if (c) c.focus();
    return true;
  }
  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    if (overlay()) overlay().hidden = true;
    lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  var lastCount = null;
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (el.classList.contains('cart-count')) {
        el.classList.toggle('is-empty', !n);
        if (lastCount !== null && n !== lastCount) { el.classList.remove('is-bump'); void el.offsetWidth; if (!reduce) el.classList.add('is-bump'); }
      }
    });
    lastCount = n;
  }
  document.addEventListener('pt:cart:updated', function (e) { if (e.detail && typeof e.detail.item_count === 'number') setCount(e.detail.item_count); });
  function getCart() { return fetch(PT.routes.cart + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function announce(cart) { document.dispatchEvent(new CustomEvent('pt:cart:updated', { detail: cart })); return cart; }
  function refreshDrawer() {
    return fetch(PT.routes.cart + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = $('#cart-drawer', new DOMParser().parseFromString(html, 'text/html'));
        var d = drawer();
        if (fresh && d) {
          d.innerHTML = fresh.innerHTML;
          if (d.classList.contains('is-open') && !d.contains(document.activeElement)) { var c = $('[data-close-cart]', d); if (c) c.focus(); }
        }
      });
  }
  /* after any add/change/remove: re-render drawer section, fetch /cart.js once, dispatch pt:cart:updated */
  function afterChange() { return refreshDrawer().then(getCart).then(announce); }
  function changeLine(line, qty) {
    return fetch(PT.routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(function (r) {
      if (!r.ok) throw new Error('change');
      if (document.body.classList.contains('template-cart')) { return getCart().then(announce).then(function () { location.reload(); }); }
      return afterChange();
    }).catch(function () { toast(PT.strings.error); });
  }
  function addItem(body, isJson) {
    var want = 1;
    try { want = parseInt(isJson ? JSON.parse(body).quantity : body.get('quantity'), 10) || 1; } catch (err) { want = 1; }
    /* R5: a request that would take the cart past the cap is never sent */
    if (!capAllows(CAP.max, CAP.count, want)) { capBlocked(); return capReject(); }
    return fetch(PT.routes.cartAdd + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: isJson ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error((j && (j.description || j.message)) || PT.strings.error); return j; });
    }).then(function () { return afterChange(); }).then(openDrawer);
  }

  /* ---------- Header: search, mobile menu, dropdowns ---------- */
  var mnav = function () { return $('#mobile-nav'); };
  function menuOpen() { var n = mnav(); return n && !n.hidden; }
  function setMenu(on) {
    var n = mnav(), t = $('[data-menu-toggle]');
    if (!n) return;
    if (on) {
      n.hidden = false; void n.offsetWidth; n.classList.add('is-open'); lastFocus = document.activeElement;
      var f = $(FOCUSABLE, n); if (f) f.focus();
    } else {
      n.classList.remove('is-open');
      setTimeout(function () { if (!n.classList.contains('is-open')) n.hidden = true; }, reduce ? 0 : 290);
      $$('.mnav__panel', n).forEach(function (p) { p.classList.remove('is-on'); p.hidden = true; });
      $('[data-mnav-main]', n).classList.remove('is-away');
      if (t) t.focus();
    }
    if (t) t.setAttribute('aria-expanded', String(on));
    lock(on);
  }
  function closeSubs(except) {
    $$('[data-nav-sub]').forEach(function (s) {
      if (s === except) return;
      var b = $('[data-nav-toggle]', s), u = $('.nav__sub', s);
      if (u) u.hidden = true; if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function openSub(s, on) {
    var b = $('[data-nav-toggle]', s), u = $('.nav__sub', s);
    if (on) closeSubs(s);
    u.hidden = !on; b.setAttribute('aria-expanded', String(on));
  }
  $$('[data-nav-sub]').forEach(function (s) {
    var tm;
    s.addEventListener('mouseenter', function () { clearTimeout(tm); tm = setTimeout(function () { openSub(s, true); }, 120); });
    s.addEventListener('mouseleave', function () { clearTimeout(tm); tm = setTimeout(function () { openSub(s, false); }, 120); });
  });

  /* ---------- Filter drawer (collection) ---------- */
  function setFilter(on) {
    var a = $('#filter-drawer'), o = $('.fdrawer-overlay'), b = $('[data-filter-open]');
    if (!a) return;
    a.hidden = !on; if (o) o.hidden = !on;
    if (b) b.setAttribute('aria-expanded', String(on));
    lock(on);
    if (on) { lastFocus = document.activeElement; var f = $(FOCUSABLE, a); if (f) f.focus(); } else if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Cards: swatch preview, quick add ---------- */
  function cardShow(card, src) {
    var img = $('.card__img--main', card);
    if (!img) return;
    if (!card._orig) card._orig = { src: img.currentSrc || img.src, srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') };
    if (src) { img.removeAttribute('srcset'); img.src = src; }
    else { if (card._orig.srcset) img.setAttribute('srcset', card._orig.srcset); img.src = card._orig.src; }
  }
  function cardSelectColor(card, sw) {
    var c = sw.getAttribute('data-swatch');
    if (card._lead === undefined) card._lead = card.getAttribute('data-color');
    card.classList.toggle('is-picked', c !== card._lead);
    card.setAttribute('data-color', c);
    $$('[data-swatch]', card).forEach(function (s) { var on = s === sw; s.classList.toggle('is-on', on); s.setAttribute('aria-pressed', String(on)); });
    $$('.chip', card).forEach(function (ch) { ch.hidden = ch.getAttribute('data-color') !== c; });
    cardShow(card, sw.getAttribute('data-src'));
    var vid = sw.getAttribute('data-vid');
    if (vid) $$('.card__link, .card__title a', card).forEach(function (a) { a.setAttribute('href', a.getAttribute('href').split('?')[0] + '?variant=' + vid); });
  }
  function quickAdd(btn) {
    var card = btn.closest('[data-card]');
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.classList.add('is-pending');
    btn.disabled = true;
    addItem(JSON.stringify({ id: Number(id), quantity: 1 }), true).catch(function (err) {
      toast((err && err.message && err.message !== 'Failed to fetch') ? err.message : PT.strings.error);
    }).then(function () { btn.classList.remove('is-pending'); btn.disabled = false; if (card) card.classList.remove('is-quick'); });
  }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-swatch]');
    if (sw) { var card = sw.closest('[data-card]'); if (sw.getAttribute('data-src')) { cardShow(card, sw.getAttribute('data-src')); card.classList.add('is-previewing'); } }
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('[data-swatch]');
    if (sw) { var card = sw.closest('[data-card]'); var on = $('[data-swatch].is-on', card); card.classList.remove('is-previewing'); cardShow(card, on && on.getAttribute('data-src')); }
  });

  /* ---------- Click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-open-cart]');
    if (open && !document.body.classList.contains('template-cart') && drawer()) {
      e.preventDefault();
      if (menuOpen()) setMenu(false);
      refreshDrawer().then(openDrawer, openDrawer);
      return;
    }
    if (t.closest('[data-close-cart]') || t.closest('.drawer-overlay')) { closeDrawer(); return; }
    var lc = t.closest('[data-line-change]');
    if (lc) {
      e.preventDefault();
      var qty = lc.getAttribute('data-qty'), row = lc.closest('[data-line]');
      var rowIn = row && $('input', row), cur = rowIn ? (parseInt(rowIn.value, 10) || 0) : 0;
      if (rowIn && !capAllows(CAP.max, CAP.count, Number(qty) - cur)) { capBlocked(); return; }
      if (qty === '0' && row && !reduce) {
        row.style.maxHeight = row.offsetHeight + 'px'; void row.offsetHeight; row.classList.add('is-removing');
        setTimeout(function () { changeLine(lc.getAttribute('data-line-change'), qty); }, 200);
      } else changeLine(lc.getAttribute('data-line-change'), qty);
      return;
    }
    var qm = t.closest('[data-qty-minus]'), qp = t.closest('[data-qty-plus]');
    if (qm || qp) {
      var input = $('input[name="quantity"]', (qm || qp).parentNode);
      if (input) {
        var v = parseInt(input.value, 10) || 1, nv = Math.max(1, qm ? v - 1 : v + 1);
        if (qp && !capAllows(CAP.max, CAP.count, nv)) { input.value = Math.max(1, capClamp(CAP.max, CAP.count, v)); capBlocked(); return; }
        input.value = nv;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    var st = t.closest('.js-search-toggle');
    if (st) {
      var p = $('#search-panel');
      if (p) {
        p.hidden = !p.hidden;
        $$('.js-search-toggle').forEach(function (b) { b.setAttribute('aria-expanded', String(!p.hidden)); });
        if (!p.hidden) { var q = $('input[type="search"]', p); if (q) q.focus(); }
      }
      return;
    }
    if (t.closest('[data-menu-toggle]')) { setMenu(!menuOpen()); return; }
    var mo = t.closest('[data-mnav-open]');
    if (mo) {
      var pn = $('#' + mo.getAttribute('data-mnav-open'));
      if (pn) { pn.hidden = false; void pn.offsetWidth; pn.classList.add('is-on'); $('[data-mnav-main]').classList.add('is-away'); var f = $(FOCUSABLE, pn); if (f) f.focus(); }
      return;
    }
    if (t.closest('[data-mnav-back]')) {
      var pp = t.closest('.mnav__panel');
      pp.classList.remove('is-on'); $('[data-mnav-main]').classList.remove('is-away');
      setTimeout(function () { if (!pp.classList.contains('is-on')) pp.hidden = true; }, reduce ? 0 : 290);
      return;
    }
    var nt = t.closest('[data-nav-toggle]');
    if (nt) { var s = nt.closest('[data-nav-sub]'); openSub(s, $('.nav__sub', s).hidden); return; }
    if (!t.closest('[data-nav-sub]')) closeSubs();
    var ft = t.closest('[data-foot-toggle]');
    if (ft) { var col = ft.closest('[data-foot-col]'); var on2 = !col.classList.contains('is-open'); col.classList.toggle('is-open', on2); ft.setAttribute('aria-expanded', String(on2)); return; }
    if (t.closest('[data-filter-open]')) { setFilter(true); return; }
    if (t.closest('[data-filter-close]')) { setFilter(false); return; }
    var sw = t.closest('[data-swatch]');
    if (sw) { cardSelectColor(sw.closest('[data-card]'), sw); return; }
    var qt = t.closest('[data-quick-toggle]');
    if (qt) { var cd = qt.closest('[data-card]'); var q2 = !cd.classList.contains('is-quick'); cd.classList.toggle('is-quick', q2); qt.setAttribute('aria-expanded', String(q2)); return; }
    var chip = t.closest('.chip[data-variant-id], [data-quick-direct]');
    if (chip) { quickAdd(chip); return; }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-auto-submit]') && e.target.form) e.target.form.submit();
  });

  /* ---------- Keyboard: Esc + focus trap ---------- */
  document.addEventListener('keydown', function (e) {
    var d = drawer(), dOpen = d && d.classList.contains('is-open');
    var fd = $('#filter-drawer'), fOpen = fd && !fd.hidden;
    var trap = dOpen ? d : (fOpen ? fd : (menuOpen() ? mnav() : null));
    if (e.key === 'Escape') {
      if (dOpen) { closeDrawer(); return; }
      if (fOpen) { setFilter(false); return; }
      if (menuOpen()) { setMenu(false); return; }
      var any = $$('[data-nav-sub] .nav__sub').some(function (u) { return !u.hidden; });
      if (any) { closeSubs(); return; }
      var sp = $('#search-panel');
      if (sp && !sp.hidden) { sp.hidden = true; $$('.js-search-toggle').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); var sb = $('.js-search-toggle'); if (sb) sb.focus(); }
      return;
    }
    if (e.key === 'Tab' && trap) {
      var f = $$(FOCUSABLE, trap).filter(function (x) { return x.offsetParent !== null && !x.closest('[hidden]'); });
      if (trap === mnav()) f = f.concat($$('[data-menu-toggle]'));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var form = $('[data-product-form]', root);
    if (!form) return;
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', root).textContent); } catch (err) { variants = []; }
    var idInput = $('[data-variant-id]', form);
    var priceEl = $('[data-price]', root), stickyPrice = $('[data-price-sticky]', root);
    var addBtn = $('[data-add-to-cart]', form), stickyBtn = $('[data-sticky-add]', root);
    var errEl = $('[data-form-error]', form);
    var qtyInput = $('input[name="quantity"]', form), qtyMinus = $('[data-qty-minus]', form), qtyPlus = $('[data-qty-plus]', form);
    var capMsg = $('[data-cap-msg]', root);
    var groups = $$('[data-option-group]', form);
    var track = $('[data-gallery-track]', root);

    function selection() { return groups.map(function (g) { var on = $('[aria-checked="true"]', g); return on ? on.getAttribute('data-value') : null; }); }
    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) { if (variants[i].options[j] !== sel[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    /* touch the DOM only when a value really changes: rewriting the button between mousedown and mouseup (the qty box's change fires on that blur) makes WebKit drop the click */
    function setText(el, t) { if (el && el.textContent !== String(t)) el.textContent = t; }
    function setBtn(btn, label, disabled) {
      if (!btn) return;
      if (btn.textContent !== String(label)) btn.textContent = label;
      if (btn.disabled !== !!disabled) btn.disabled = !!disabled;
      if (btn.hasAttribute('aria-busy')) btn.removeAttribute('aria-busy');
    }
    function showMedia(id) {
      if (!id) return;
      $$('[data-thumb]', root).forEach(function (b) { b.setAttribute('aria-current', String(b.getAttribute('data-thumb') === String(id))); });
      var slide = $('.gallery__slide[data-media-id="' + id + '"]', root);
      /* instant swap: no smooth scroll, so the main image is already the chosen color when the click lands */
      if (track && slide && track.scrollWidth > track.clientWidth) track.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
      var curEl = $('[data-gal-cur]', root), all = $$('.gallery__slide[data-media-id]', root);
      if (curEl && slide) curEl.textContent = all.indexOf(slide) + 1;
    }
    /* a color photo was chosen (thumbnail tap or swipe): tick the matching color swatch, keep the size, update the URL */
    function syncSwatch(id) {
      var gi = -1;
      groups.forEach(function (g, i) { if (gi < 0 && g.classList.contains('swatches')) gi = i; });
      if (gi < 0) return;
      var cands = variants.filter(function (x) { return String(x.media) === String(id); });
      if (!cands.length) return;
      var sel = selection();
      var best = cands.filter(function (x) { return x.options.every(function (o, j) { return j === gi || o === sel[j]; }); })[0] || cands[0];
      var val = best.options[gi];
      var changed = false;
      $$('[role="radio"]', groups[gi]).forEach(function (x) { var on = x.getAttribute('data-value') === val; if (on && x.getAttribute('aria-checked') !== 'true') changed = true; x.setAttribute('aria-checked', String(on)); x.tabIndex = on ? 0 : -1; });
      if (changed) update(gi, true);
    }
    function markUnavailable(sel) {
      groups.forEach(function (g, gi) {
        $$('[role="radio"]', g).forEach(function (b) {
          var probe = sel.slice(); probe[gi] = b.getAttribute('data-value');
          var v = findVariant(probe);
          var bad = !v || !v.available;
          b.classList.toggle('is-unavail', bad);
          if (bad) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
        });
      });
    }
    /* cap on the PDP: stepper max = remaining room, Add to cart locked at the cap, message in the reserved line */
    function applyBlock() {
      var full = capLeftOf(CAP.max, CAP.count) < 1;
      [addBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        if (full) { if (!b.disabled) b.disabled = true; if (b.getAttribute('aria-disabled') !== 'true') b.setAttribute('aria-disabled', 'true'); }
        else if (b.hasAttribute('aria-disabled')) b.removeAttribute('aria-disabled');
      });
    }
    function capSync() {
      var left = capLeftOf(CAP.max, CAP.count), full = left < 1, atMax = full;
      if (qtyInput) {
        if (qtyInput.max !== String(left)) qtyInput.max = String(left);
        if (qtyInput.disabled !== full) qtyInput.disabled = full;
        var cur = parseInt(qtyInput.value, 10) || 1;
        if (!full && cur > left) qtyInput.value = String(left);
        else if (full && qtyInput.value !== '1') qtyInput.value = '1';
        var now = parseInt(qtyInput.value, 10) || 1;
        if (qtyMinus && qtyMinus.disabled !== (full || now <= 1)) qtyMinus.disabled = full || now <= 1;
        if (qtyPlus && qtyPlus.disabled !== (full || now >= left)) qtyPlus.disabled = full || now >= left;
        if (now >= left) atMax = true;
      }
      /* message shows at the cap and whenever the stepper has reached the room that is left */
      if (capMsg && capMsg.hidden !== !atMax) capMsg.hidden = !atMax;
      update();
    }
    CAP.hooks.push(capSync);
    function update(changedIndex, keepMedia) {
      var sel = selection();
      groups.forEach(function (g, i) { var lab = $('[data-option-label="' + i + '"]', root); setText(lab, sel[i] || ''); });
      markUnavailable(sel);
      var v = findVariant(sel);
      if (!v) { idInput.value = ''; setBtn(addBtn, PT.strings.unavailable, true); setBtn(stickyBtn, PT.strings.unavailable, true); applyBlock(); return; }
      idInput.value = v.id;
      setText(priceEl, v.price);
      setText(stickyPrice, v.price);
      setBtn(addBtn, v.available ? PT.strings.addToCart + ' - ' + v.price : PT.strings.soldOut, !v.available);
      setBtn(stickyBtn, v.available ? PT.strings.addToCart : PT.strings.soldOut, !v.available);
      applyBlock();
      if (errEl && !errEl.hidden) errEl.hidden = true;
      if (changedIndex !== undefined && !keepMedia) {
        if (v.media) showMedia(v.media);
        else {
          /* no image assigned to this variant: follow the photo whose alt text opens with the chosen color */
          groups.forEach(function (g, gi) {
            if (!g.classList.contains('swatches') || !sel[gi]) return;
            var want = String(sel[gi]).toLowerCase();
            var hit = $$('[data-media-id]', root).filter(function (s) { var im = $('img', s); return im && String(im.alt || '').toLowerCase().indexOf(want) === 0; })[0];
            if (hit) showMedia(hit.getAttribute('data-media-id'));
          });
        }
      }
      if (window.history && history.replaceState && changedIndex !== undefined) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }
    update();
    if (qtyInput) qtyInput.addEventListener('change', function () {
      var want = parseInt(qtyInput.value, 10), left = capLeftOf(CAP.max, CAP.count);
      if (isNaN(want) || want < 1) qtyInput.value = '1';
      else if (left > 0 && want > left) qtyInput.value = String(capClamp(CAP.max, CAP.count, want));
      capSync();
    });
    capSync();
    groups.forEach(function (g, gi) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[role="radio"]');
        if (!b) return;
        $$('[role="radio"]', g).forEach(function (x) { var on = x === b; x.setAttribute('aria-checked', String(on)); x.tabIndex = on ? 0 : -1; });
        update(gi);
      });
      g.addEventListener('keydown', function (e) {
        var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        if (!keys[e.key]) return;
        var radios = $$('[role="radio"]', g), i = radios.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var n = radios[(i + keys[e.key] + radios.length) % radios.length];
        n.focus(); n.click();
      });
    });

    form.addEventListener('submit', function (e) {
      var wantQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      if (!capAllows(CAP.max, CAP.count, wantQty)) { e.preventDefault(); capSync(); return; }
      if (!window.fetch || !idInput.value) return;
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.style.minWidth = addBtn.offsetWidth + 'px';
      addBtn.setAttribute('aria-busy', 'true');
      addBtn.innerHTML = PT.strings.adding + ' <span class="dots" aria-hidden="true"><i></i><i></i><i></i></span>';
      addBtn.disabled = true;
      addItem(new FormData(form), false).catch(function (err) {
        if (err && err.cap) return;
        var msg = (err && err.message && err.message !== 'Failed to fetch') ? err.message : PT.strings.error;
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; } else toast(msg);
      }).then(function () { addBtn.style.minWidth = ''; update(); });
    });

    var bar = $('[data-sticky-bar]', root);
    if (bar && addBtn && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-bar');
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(addBtn);
    }

    var gallery = $('[data-gallery]', root);
    if (gallery && track) {
      var cur = $('[data-gal-cur]', gallery);
      gallery.addEventListener('click', function (e) {
        var b = e.target.closest('[data-thumb]');
        if (b) { var tid = b.getAttribute('data-thumb'); showMedia(tid); syncSwatch(tid); return; }
        var dir = e.target.closest('[data-gal-next]') ? 1 : (e.target.closest('[data-gal-prev]') ? -1 : 0);
        if (dir) track.scrollBy({ left: dir * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      });
      var timer;
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var slides = $$('[data-media-id]', track), s = slides[Math.round(track.scrollLeft / (track.clientWidth || 1))];
          if (!s) return;
          if (cur) cur.textContent = slides.indexOf(s) + 1;
          $$('[data-thumb]', gallery).forEach(function (d) { d.setAttribute('aria-current', String(d.getAttribute('data-thumb') === s.getAttribute('data-media-id'))); });
          var cv = findVariant(selection()), mid = s.getAttribute('data-media-id');
          if (!cv || String(cv.media) !== String(mid)) syncSwatch(mid);
        }, 80);
      }, { passive: true });
      var first = $('[data-thumb][aria-current="true"]', gallery);
      if (first) showMedia(first.getAttribute('data-thumb'));
      initZoom(track);
      initLightbox(root, gallery, track);
    }
  }

  /* ---------- PDP lightbox (v07.2 r2): native <dialog>, Esc closes, focus returns to the opener ---------- */
  function initLightbox(root, gallery, track) {
    var dlg = $('[data-lightbox]', root), big = dlg && $('[data-lb-img]', dlg);
    if (!dlg || !big) return;
    var opener = null, idx = 0;
    var prevB = $('[data-lb-prev]', dlg), nextB = $('[data-lb-next]', dlg);
    function show(img) { big.src = bigSrc(img); big.alt = img.alt || ''; }
    /* r3-p1 F07: step through the gallery slides that carry an image, wrapping at the ends; the gallery scrolls with it so close lands on the same slide */
    function step(d) {
      var slides = $$('.gallery__slide', track).filter(function (sl) { return $('img', sl); });
      if (slides.length < 2) return;
      var cur = slides.indexOf($$('.gallery__slide', track)[idx]);
      if (cur < 0) cur = 0;
      var nx = (cur + d + slides.length) % slides.length;
      idx = $$('.gallery__slide', track).indexOf(slides[nx]);
      show($('img', slides[nx]));
      track.scrollTo ? track.scrollTo({ left: slides[nx].offsetLeft - track.offsetLeft, behavior: 'auto' }) : (track.scrollLeft = slides[nx].offsetLeft);
    }
    function curSlide() {
      var slides = $$('.gallery__slide', track);
      return slides[Math.round(track.scrollLeft / (track.clientWidth || 1))] || slides[0];
    }
    function bigSrc(img) {
      var set = img.getAttribute('srcset') || '', src = img.currentSrc || img.src, best = 0;
      if (/cdn\.shopify|[?&]v=/.test(src) && /[?&]width=/.test(src)) { try { var u = new URL(src, location.href); u.searchParams.set('width', '2000'); return u.href; } catch (err) { return src; } }
      set.split(',').forEach(function (part) { var m = part.trim().match(/^(\S+)\s+(\d+)w$/); if (m && +m[2] > best) { best = +m[2]; src = m[1]; } });
      return src;
    }
    function open(from) {
      var s = curSlide(), img = s && $('img', s);
      if (!img) return;
      opener = from || document.activeElement;
      idx = $$('.gallery__slide', track).indexOf(s);
      show(img);
      if (dlg.showModal) { if (!dlg.open) dlg.showModal(); } else { dlg.setAttribute('open', ''); }
      var cb = $('[data-lb-close]', dlg); if (cb) cb.focus();
    }
    function close() { if (dlg.close && dlg.open) dlg.close(); else dlg.removeAttribute('open'); }
    dlg.addEventListener('close', function () { big.removeAttribute('src'); if (opener && opener.focus) opener.focus(); opener = null; });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-lb-close]')) close(); });
    /* bound to the document while open: Safari does not focus a clicked button, so keys would otherwise miss the dialog */
    function onKey(e) {
      if (!dlg.open) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === 'Tab') {
        /* focus trap: the modal dialog already inerts the page; this keeps Tab cycling inside it */
        var f = $$('button:not([disabled])', dlg); if (!f.length) return;
        var a = document.activeElement;
        if (e.shiftKey && (a === f[0] || !dlg.contains(a))) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && (a === f[f.length - 1] || !dlg.contains(a))) { e.preventDefault(); f[0].focus(); }
      }
    }
    document.addEventListener('keydown', onKey);
    if (prevB) prevB.addEventListener('click', function () { step(-1); prevB.focus(); });
    if (nextB) nextB.addEventListener('click', function () { step(1); nextB.focus(); });
    var zb = $('[data-gal-zoom]', gallery);
    if (zb) zb.addEventListener('click', function () { open(zb); });
    track.addEventListener('click', function (e) { var s = e.target.closest && e.target.closest('.gallery__slide'); if (s && $('img', s)) open(zb || track); });
  }

  /* ---------- PDP main-image hover zoom (v07.1): desktop mouse only, nothing is attached on touch ----------
     Hover starts the zoom. A click on the image toggles a lock for the rest of the page view: locked = no zoom,
     click again = zoom allowed. Leaving the image stops the zoom but never touches the lock.
     Keyboard: the image is not a tab stop and has no keyboard zoom; focus anywhere is unaffected. */
  function initZoom(track) {
    if (!window.matchMedia) return;
    var mq = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    var on = false, locked = false, loaded = {};
    var gal = track.closest('[data-gallery]') || track;
    function slideOf(t) { return t && t.closest ? t.closest('.gallery__slide') : null; }
    function hires(img) {
      /* first hover: fetch the same image at up to 2000px wide, swap it in once cached (same box, no layout change) */
      var src = img.currentSrc || img.src;
      if (!src || loaded[src] || /^data:/.test(src)) return;
      loaded[src] = 1;
      var u;
      try { u = new URL(src, location.href); } catch (err) { return; }
      u.searchParams.set('width', '2000');
      var big = new Image();
      big.onload = function () { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = u.href; loaded[u.href] = 1; };
      big.src = u.href;
    }
    function reset() { $$('.gallery__slide.is-zoomed', track).forEach(function (s) { s.classList.remove('is-zoomed'); }); }
    function setLock(v) { locked = v; gal.classList.toggle('is-zoom-off', v); if (v) reset(); }
    function aim(e, s) {
      var r = s.getBoundingClientRect();
      if (!r.width || !r.height) return false;
      s.style.setProperty('--zx', Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100)).toFixed(1) + '%');
      s.style.setProperty('--zy', Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100)).toFixed(1) + '%');
      return true;
    }
    function start(e, s, img) {
      if (!aim(e, s)) return;
      if (!s.classList.contains('is-zoomed')) { reset(); s.classList.add('is-zoomed'); hires(img); }
    }
    function move(e) {
      if (e.pointerType === 'touch' || locked) return;
      var s = slideOf(e.target), img = s && $('img', s);
      if (!img) { reset(); return; }
      start(e, s, img);
    }
    function click(e) {
      /* v07.2 r2: a click opens the lightbox dialog (wired in initProduct); hover zoom is no longer toggled by click */
      return;
    }
    function attach() {
      if (on) return;
      on = true;
      track.addEventListener('pointermove', move);
      track.addEventListener('pointerleave', reset);
      track.addEventListener('click', click);
      track.addEventListener('scroll', reset, { passive: true });
    }
    function detach() {
      if (!on) return;
      on = false; reset();
      track.removeEventListener('pointermove', move);
      track.removeEventListener('pointerleave', reset);
      track.removeEventListener('click', click);
      track.removeEventListener('scroll', reset);
    }
    function sync() { if (mq.matches) attach(); else detach(); }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
  }

  function init() {
    $$('[data-pdp]').forEach(function (p) { initProduct(p.closest('section') || document); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* r4-f START: newsletter validation */
/* r4-f */
(function () {
  var form = document.getElementById('footer-newsletter');
  if (!form) return;
  form.noValidate = true;
  var input = form.querySelector('input[type=email]');
  var note = form.querySelector('[data-news-status]');
  if (!input || !note) return;
  var msg = note.getAttribute('data-err') || "That's not an email. Try again.";
  var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  form.addEventListener('submit', function (e) {
    var v = (input.value || '').trim();
    if (!ok.test(v)) {
      e.preventDefault();
      note.textContent = '';
      var s = document.createElement('span');
      s.className = 'form-note__err';
      s.textContent = msg;
      note.appendChild(s);
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }
  });
  input.addEventListener('input', function () {
    if (note.querySelector('.form-note__err')) note.textContent = '';
    input.removeAttribute('aria-invalid');
  });
})();
/* /r4-f */

/* r4-f END */

/* ===== r6-a start (builder-a) ===== */
/* ===== r6-a end ===== */
/* ===== r6-b start (builder-b) ===== */
/* r6-b F27 + F28: menu/drawer Tab trap that does not depend on browser tab order; focus returns to the opener.
   Safari does not focus clicked buttons, so document.activeElement is BODY at open time: the opener is recorded from the click target instead. */
(function () {
  var SEL = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var opener = null;
  function vis(el) { return el.offsetParent !== null && !el.closest('[hidden]') && !el.closest('[inert]'); }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('button, a, [role="button"], summary') : null;
    if (t && !t.closest('#cart-drawer') && !t.closest('#mobile-nav')) opener = t;
  }, true);
  function trapRoot() {
    var d = document.getElementById('cart-drawer'), m = document.getElementById('mobile-nav'), f = document.getElementById('filter-drawer');
    if (d && d.classList.contains('is-open')) return d;
    if (f && !f.hidden) return f;
    if (m && !m.hidden && m.classList.contains('is-open')) return m;
    return null;
  }
  function items(root) {
    var l = Array.prototype.slice.call(root.querySelectorAll(SEL)).filter(vis);
    if (root.id === 'mobile-nav') { var t = document.querySelector('[data-menu-toggle]'); if (t && vis(t)) l.push(t); }
    return l;
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var root = trapRoot(); if (!root) return;
    var l = items(root); if (!l.length) return;
    var i = l.indexOf(document.activeElement), n;
    if (e.shiftKey) n = i <= 0 ? l[l.length - 1] : l[i - 1]; else n = (i < 0 || i === l.length - 1) ? l[0] : l[i + 1];
    e.preventDefault(); e.stopPropagation(); n.focus();
  }, true);
  document.addEventListener('focusin', function (e) {
    var root = trapRoot(); if (!root || root.contains(e.target)) return;
    if (root.id === 'mobile-nav' && e.target.closest && e.target.closest('[data-menu-toggle]')) return;
    var l = items(root); if (l.length) l[0].focus();
  });
  var dr = document.getElementById('cart-drawer');
  if (dr && window.MutationObserver) {
    var was = dr.classList.contains('is-open');
    new MutationObserver(function () {
      var now = dr.classList.contains('is-open');
      if (was && !now) {
        var o = opener && document.contains(opener) && vis(opener) ? opener : document.querySelector('.cart-link');
        if (o) setTimeout(function () { o.focus(); }, 0);
      }
      was = now;
    }).observe(dr, { attributes: true, attributeFilter: ['class'] });
  }
})();
/* ===== r6-b end ===== */
